import React from 'react';
import { useState } from 'react';
import { Skeleton } from 'antd';
import { Header } from './Components/Header';
import { useOWASContext } from '../../context';
import { Comments } from './Components/Comment';
import { TaskRisk } from './Components/TaskRisk';
import { DownloadPDF } from './DownloadPDF/index';
import { Informations } from './Components/Informations';
import { ActivityRisk } from './Components/ActivityRisk';
import { useGetOWASResult } from '../../hooks/useGetResult';
import { GeneralInformations } from './Components/GeneralInformations';
import { ResultsContainer, SectionDivider } from './styles';

export function Content(): JSX.Element {
	const { parameters, data } = useOWASContext();
	const [isEditing, setIsEditing] = useState<boolean>(false);

	const {
		isInitialLoading,
		data: result,
		isError
	} = useGetOWASResult({
		organization_id: parameters?.organization_id!,
		company_id: parameters?.company_id!,
		file_id: parameters?.file_id!,
		id: data?.id!,
		finished: true
	});

	function handleDisableFormEdition(editing: boolean): void {
		setIsEditing(editing);
	}

	if (isError) {
		return <h2>isError</h2>;
	}

	return (
		<ResultsContainer>
			<Header />
			<SectionDivider type="horizontal" />
			<Skeleton loading={isInitialLoading}>
				{result?.informations && <Informations data={result.informations} />}
			</Skeleton>
			<SectionDivider type="horizontal" />
			<Skeleton loading={isInitialLoading}>
				{result?.general_informations && <GeneralInformations data={result.general_informations} />}
			</Skeleton>
			<SectionDivider type="horizontal" />
			<Skeleton loading={isInitialLoading}>
				{result?.overall_activity_task && <ActivityRisk data={result.overall_activity_task} />}
			</Skeleton>
			<SectionDivider type="horizontal" />
			<Skeleton loading={isInitialLoading}>{result?.tasks && <TaskRisk data={result.tasks} />}</Skeleton>
			<Comments
				onCommentChange={handleDisableFormEdition}
				disabled={isEditing || isInitialLoading || data?.is_consolidated}
			/>
			<DownloadPDF isConsolidated={!!result?.informations?.is_consolidated} />
		</ResultsContainer>
	);
}
